function extractPersnr(value) {
  return String(value || "").split(" (")[0]
}

function applyEmployeeAssignmentResponse(row, response, submittedPersnr) {
  if (!row || !response || response.status !== "success") return false
  if (extractPersnr(row.Mitarbeiternr) !== extractPersnr(submittedPersnr)) return false

  row.Mitarbeiter_Vorname = response.Mitarbeiter_Vorname
  row.Mitarbeiter_Nachname = response.Mitarbeiter_Nachname
  if (response.Mitarbeitername !== undefined) row.Mitarbeitername = response.Mitarbeitername
  if (response.id !== undefined && response.id !== null) row.id = response.id
  return true
}

module.exports = {
  extractPersnr,
  applyEmployeeAssignmentResponse
}
